import { indexes } from '@mab-common/utils'

import type { ArtworkCardProps } from '~/components/atoms/ArtworkCard/ArtworkCard'
import {
  buildElasticResultSourceFields,
  buildElasticSortFields,
} from '~/services/elastic/builder'
import { useElasticQuery } from '~/services/query/use-elastic-query'
import EsIndexTypes = indexes.EsIndexTypes
import RecordTypes = indexes.RecordTypes

export default function useLatestArtworks() {
  return useElasticQuery<ArtworkCardProps>(RecordTypes.LATEST_ARTWORK, {
    index: EsIndexTypes.ARTWORKS,
    searches: [
      {},
      {
        from: 0,
        size: 9,
        _source: buildElasticResultSourceFields(RecordTypes.ARTWORK),
        sort: buildElasticSortFields(RecordTypes.LATEST_ARTWORK),
        query: {
          bool: {
            must_not: [
              {
                term: {
                  isVisible: false,
                },
              },
            ],
            filter: [
              {
                term: {
                  type: 'artwork',
                },
              },
            ],
          },
        },
      },
    ],
  })
}
